import { render, staticRenderFns } from "./RobotTeachingRecords.vue?vue&type=template&id=72847d8d&scoped=true"
import script from "./RobotTeachingRecords.vue?vue&type=script&lang=js"
export * from "./RobotTeachingRecords.vue?vue&type=script&lang=js"
import style0 from "./RobotTeachingRecords.vue?vue&type=style&index=0&id=72847d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72847d8d",
  null
  
)

export default component.exports